import React, { useState } from 'react';
import { Collapse } from 'reactstrap';

function ViewMySkill(props) {
    const [collapse, setCollapse] = useState(false);
    const toggle = () => setCollapse(!collapse);
    return (
    <div className="mg-t-20" >
        <div className="card" >
            <div className="card-header">
                <div className="card-header-left">
                    <h5>Expertise Category & Skills</h5>
                </div>
                <div className="card-header-right">
                    <ul className="row" > 
                        <li><i className={collapse ? "fa fa-chevron-down" : "fa fa-chevron-up"} onClick={toggle}></i></li>                                 
                    </ul>            
                </div>
            </div>            
            <Collapse isOpen={!collapse}> 
            <hr className="mg-l-20 mg-b-0" ></hr>           
            <div className="card-block">  
                <div className="col-md-12">
                <div className="row mg-b-10 pd-t-5 pd-b-5 list-header b-b-border">
                    <div className="wd-pct-26 pd-l-5">Category                     
                    </div>
                    <div className="wd-pct-74 pd-l-15">
                        <div className="row ">
                            <div className="wd-pct-21 ">Skill</div>
                            <div className="wd-pct-24 text-center">Skill Score </div>
                            <div className="wd-pct-21 text-center">Difficulty Level </div>
                            <div className="wd-pct-34 text-center"></div>
                        </div>
                    </div>                                              
                </div>
                <div className="v-align mg-b-15">
                    <div className="wd-pct-26  ">
                        <div className="card-list-header">Web & Software Development</div>
                    </div>
                    <div className="b-l-border wd-pct-74 pd-l-15">                                                     
                        <div className="row v-align pd-b-5 ">
                            <div className="wd-pct-21">Python</div>
                            
                            <div className="d-flex wd-pct-24 text-center v-align">
                                <div className="wd-pct-70 score-progress">
                                    <div className="score-progress-bar" style={{width:'80%'}}></div>                        
                                </div>
                                <div className="wd-pct-30 text-right">80%</div>
                            </div>
                            <div className="wd-pct-21 text-center">
                                <div className="label label-success-lite wd-pct-56" style={{marginLeft:'auto', marginRight:'auto'}}>Advanced</div>
                            </div>
                            <div className="wd-pct-34 text-center"></div>
                        </div>
                        <div className="row v-align pd-b-5">
                            <div className="wd-pct-21">Reactjs</div>
                            
                            <div className="d-flex wd-pct-24 text-center v-align">
                                <div className="wd-pct-70 score-progress">
                                    <div className="score-progress-bar" style={{width:'40%'}}></div>                        
                                </div>
                                <div className="wd-pct-30 text-right">40%</div>
                            </div>
                            <div className="wd-pct-21 text-center">
                                <div className="label label-default-lite wd-pct-56" style={{marginLeft:'auto', marginRight:'auto'}}>Basic</div>
                            </div>
                            <div className="wd-pct-34 text-center"></div>
                        </div>
                        <div className="row v-align pd-b-5">
                            <div className="wd-pct-21">Html</div>
                            
                            <div className="d-flex wd-pct-24 text-center v-align">
                                <div className="wd-pct-70 score-progress">
                                    <div className="score-progress-bar" style={{width:'0%'}}></div>                        
                                </div>
                                <div className="wd-pct-30 text-right">-</div>
                            </div>
                            <div className="wd-pct-21 text-center">
                                <div className="label label-danger-lite wd-pct-56" style={{marginLeft:'auto', marginRight:'auto'}}>None</div>
                            </div>
                            <div className="wd-pct-34 text-center"></div>
                        </div>
                      
                    </div>                          
                </div>
                <hr className="mg-r-0" ></hr>
                <div className="row mg-b-10">
                    <div className="wd-pct-26 v-align pd-l-5 card-list-header">Data Science & Analytics</div>
                    <div className="b-l-border  wd-pct-74 pd-l-15">                                    
                    <div className="row v-align pd-b-5 ">
                            <div className="wd-pct-21">Economics</div>
                            
                            <div className="d-flex wd-pct-24 text-center v-align">
                                <div className="wd-pct-70 score-progress">
                                    <div className="score-progress-bar" style={{width:'60%'}}></div>                        
                                </div>
                                <div className="wd-pct-30 text-right">60%</div>
                            </div>
                            <div className="wd-pct-21 text-center">
                                <div className="label label-warning-lite wd-pct-56" style={{marginLeft:'auto', marginRight:'auto'}}>Medium</div>
                            </div>
                            <div className="wd-pct-34 text-center"></div>
                        </div>
                        <div className="row v-align pd-b-5 ">
                            <div className="wd-pct-21">Econometrics</div>
                            
                            <div className="d-flex wd-pct-24 text-center v-align">
                                <div className="wd-pct-70 score-progress">
                                    <div className="score-progress-bar" style={{width:'90%'}}></div>                        
                                </div>
                                <div className="wd-pct-30 text-right">90%</div>
                            </div>
                            <div className="wd-pct-21 text-center">
                                <div className="label label-success-lite wd-pct-56" style={{marginLeft:'auto', marginRight:'auto'}}>Advanced</div>
                            </div>
                            <div className="wd-pct-34 text-center"></div>
                        </div>
                        <div className="row v-align pd-b-5">
                            <div className="wd-pct-21">SAS</div>
                            
                            <div className="d-flex wd-pct-24 text-center v-align">
                                <div className="wd-pct-70 score-progress">
                                    <div className="score-progress-bar" style={{width:'40%'}}></div>                        
                                </div>
                                <div className="wd-pct-30 text-right">40%</div>
                            </div>
                            <div className="wd-pct-21 text-center">
                                <div className="label label-default-lite wd-pct-56" style={{marginLeft:'auto', marginRight:'auto'}}>Basic</div>
                            </div>
                            <div className="wd-pct-34 text-center"></div>
                        </div>
                        <div className="row v-align pd-b-5">
                            <div className="wd-pct-21">SQL</div>
                            
                            <div className="d-flex wd-pct-24 text-center v-align">
                                <div className="wd-pct-70 score-progress">
                                    <div className="score-progress-bar" style={{width:'70%'}}></div>                        
                                </div>
                                <div className="wd-pct-30 text-right">70%</div>
                            </div>
                            <div className="wd-pct-21 text-center">
                                <div className="label label-default-lite wd-pct-56" style={{marginLeft:'auto', marginRight:'auto'}}>Basic</div>
                            </div>
                            <div className="wd-pct-34 text-center"></div>
                        </div>
                    </div>                             
                </div>
            </div>
        </div>
            </Collapse>
        </div>
    </div>
        
    );
  }

export default ViewMySkill